// extracted by mini-css-extract-plugin
module.exports = {"root":"aGcyBm","more":"_1vsdv4","moreLink":"_1nHBj5","moreLinkWhite":"wrU0iI","title":"_2VwrW1","asideTitle":"_2iQY0a","footerTitle":"_1aa1Vl","readMoreButton":"_2GoYiw"};